import * as Sentry from "@sentry/react";

/**
 * Initialize Sentry error tracking
 * Only runs in production mode
 */
export function initSentry() {
  // TEMPORAIRE: Guards désactivés pour tester l'intégration
  // TODO: Remettre les guards après validation
  // if (import.meta.env.DEV) {
  //   console.log("[Sentry] Skipped initialization in development mode");
  //   return;
  // }

  Sentry.init({
    dsn: "https://4c5c3c1ddfa56c74e666ae6636d86c66@o4510839821303808.ingest.de.sentry.io/4510839840571472",
    environment: import.meta.env.MODE,
    release: "piktable@1.0.0",
    
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    
    // Capture 100% of errors
    tracesSampleRate: 1.0,
    
    // Session Replay - 10% in prod, 100% on error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    
    // Filter out non-relevant errors
    beforeSend(event) {
      // Ignore temporary network errors
      if (event.exception?.values?.[0]?.type === "NetworkError") {
        return null;
      }
      // Ignore ResizeObserver errors (browser quirk)
      if (event.exception?.values?.[0]?.value?.includes("ResizeObserver")) {
        return null;
      }
      return event;
    },
  });
}

/**
 * Capture an exception with optional context
 */
export function captureError(error: Error, context?: Record<string, unknown>) {
  // TEMPORAIRE: Guard désactivé pour tester
  // if (import.meta.env.DEV) {
  //   console.error("[Sentry] Would capture:", error, context);
  //   return;
  // }
  
  Sentry.captureException(error, {
    extra: context,
  });
}

/**
 * Capture a message with severity level
 */
export function captureMessage(
  message: string, 
  level: "info" | "warning" | "error" = "error"
) {
  // TEMPORAIRE: Guard désactivé pour tester
  // if (import.meta.env.DEV) {
  //   console.log(`[Sentry] Would capture message (${level}):`, message);
  //   return;
  // }
  
  Sentry.captureMessage(message, level);
}

/**
 * Set user context for error tracking
 */
export function setUser(userId: string, email: string, establishmentId?: string) {
  Sentry.setUser({
    id: userId,
    email,
    establishment_id: establishmentId,
  });
}

/**
 * Clear user context (on logout)
 */
export function clearUser() {
  Sentry.setUser(null);
}

/**
 * Create a custom span for performance tracking
 */
export function startSpan<T>(
  options: { op: string; name: string; attributes?: Record<string, unknown> },
  callback: (span: Sentry.Span) => T
): T {
  return Sentry.startSpan(
    {
      op: options.op,
      name: options.name,
    },
    (span) => {
      if (options.attributes) {
        Object.entries(options.attributes).forEach(([key, value]) => {
          span.setAttribute(key, value as string | number | boolean);
        });
      }
      return callback(span);
    }
  );
}

export { Sentry };
